import React from 'react';
import { Layers } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../ui/tabs';
import { MigracionPaso } from './MigracionPaso';
import { MigracionEpisodiosResultado } from './MigracionEpisodiosResultado';
import { FusionDuplicadosResultado } from './FusionDuplicadosResultado';

const ADMIN = ['ADMIN', 'SUPERADMIN', 'ADMINISTRADOR'];

const bloqueoFusion = (r) => (r.casos_a_fusionar > 0 ? null : 'No hay casos duplicados para fusionar.');
const bloqueoEpisodios = (r) => (r.duplicados_pendientes > 0
  ? `Quedan ${r.duplicados_pendientes} casos duplicados por fusionar: ejecutá primero el paso 1 y volvé a correr esta vista previa.`
  : null);

export const MigracionEpisodiosAccion = () => {
  const { user } = useAuth();
  const [open, setOpen] = React.useState(false);
  if (!ADMIN.includes((user?.rol || '').toUpperCase())) return null;
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="migracion-episodios-btn">
        <Layers size={16} className="mr-2" /> Migración a episodios
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto" data-testid="migracion-episodios-dialog">
          <DialogHeader>
            <DialogTitle>Migración de alertas a episodios</DialogTitle>
            <DialogDescription>
              La vista previa solo lee. Ejecutar hace primero un backup; los casos cerrados no se tocan. Primero se fusionan los duplicados.
            </DialogDescription>
          </DialogHeader>
          {open && (
            <Tabs defaultValue="duplicados">
              <TabsList>
                <TabsTrigger value="duplicados" data-testid="migracion-tab-duplicados">1. Fusionar duplicados</TabsTrigger>
                <TabsTrigger value="episodios" data-testid="migracion-tab-episodios">2. Migrar a episodios</TabsTrigger>
              </TabsList>
              <TabsContent value="duplicados" className="pt-3">
                <MigracionPaso tipo="duplicados" prefijo="migracion-duplicados" textoEjecutar="Fusionar duplicados" bloqueo={bloqueoFusion}>
                  {(r) => <FusionDuplicadosResultado r={r} />}
                </MigracionPaso>
              </TabsContent>
              <TabsContent value="episodios" className="pt-3">
                <MigracionPaso tipo="episodios" prefijo="migracion-episodios" textoEjecutar="Ejecutar migración" bloqueo={bloqueoEpisodios}>
                  {(r) => <MigracionEpisodiosResultado r={r} />}
                </MigracionPaso>
              </TabsContent>
            </Tabs>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
